import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { WorkOrderFindResult } from "@/types/find/work-orders/WorkOrderFindResult";
import { DxColumn } from "devextreme-vue/cjs/data-grid";


export default /*#__PURE__*/_defineComponent({
  __name: 'find-work-order-results',
  props: {
  /**
   * An array containing the search results for work orders.
   * Each item in the array represents a work order found during the search.
   * @type {WorkOrderFindResult[]}
   * @required
   */
  data: {
    type: Array as PropType<WorkOrderFindResult[]>,
    required: true,
  },
  /**
   * Indicates whether a search operation is currently in progress.
   * @type {boolean}
   * @default false
   */
  searching: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Emits an event when a row is clicked.
   * Passes the selected work order data to the parent component.
   * @param {WorkOrderFindResult} e - The clicked row's work order data.
   */
  "rowClick",
  /**
   * Emits an event when a row is selected.
   * Sends both the work order data and the row index to the parent component.
   * @param {WorkOrderFindResult} e - The selected row's work order data.
   * @param {number} rowIndex - The index of the selected row.
   */
  "rowSelected",
],
  setup(__props, { emit }) {





/** Handles the grid row click event */
const onRowClick = (e: WorkOrderFindResult) => emit("rowClick", e);

/** Handles the grid row selected event */
const onRowSelected = (e: WorkOrderFindResult, rowIndex: number) => {
  emit("rowSelected", e, rowIndex);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GridBase, {
    "data-source": __props.data,
    "id-column-name": "id",
    loading: __props.searching,
    "show-column-filters": false,
    "show-search-panel": false,
    "word-wrap-enabled": true,
    onRowClick: onRowClick,
    onRowSelected: onRowSelected
  }, {
    columns: _withCtx(() => [
      _createVNode(_unref(DxColumn), {
        "data-field": "id",
        caption: "Id",
        "hiding-priority": 7,
        width: "60px"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "reference",
        caption: "Reference",
        width: "100px",
        "hiding-priority": 6
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "subject",
        caption: "Subject",
        width: "120px",
        "hiding-priority": 5
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "status",
        caption: "Status",
        width: "100px",
        "hiding-priority": 4
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "contractor",
        caption: "Contractor",
        width: "120px",
        "hiding-priority": 3
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "property",
        caption: "Property",
        "hiding-priority": 2
      })
    ]),
    _: 1
  }, 8, ["data-source", "loading"]))
}
}

})